/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_HeadlineInputs */

const en_landing_hero_headline = /** @type {(inputs: Landing_Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The headless engine for your next SaaS.`)
};

const zh_landing_hero_headline = /** @type {(inputs: Landing_Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一小时上线你的 AI 产品`)
};

/**
* | output |
* | --- |
* | "The headless engine for your next SaaS." |
*
* @param {Landing_Hero_HeadlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_hero_headline = /** @type {((inputs?: Landing_Hero_HeadlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_HeadlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_headline(inputs)
	return zh_landing_hero_headline(inputs)
});
export { landing_hero_headline as "landing.hero.headline" }